import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import "./style.scss";

import UploadStatusTable from "../../../AdminUpload/components/UploadStatusTable";

// import UploadFile from "./components/UploadFile";
import UploadFile from "../../../AdminUpload/components/UploadFile";

const AdminUpload = ({ expiration, user_type }) => {
  const categorizationUploadModules = [
    {
      id: 11,
      title: "Merchant KYC uploader",
      api: "/upload-merchant-kyc-data",
      //   userTypes: ["bkash-super-user"],
    },
  ];

  let current_time = Date.now().valueOf() / 1000;
  if (expiration < current_time) this.props.signOut();

  const filteUserTypePermission = (i) => {
    var filterPass = false;
    if (!i.userTypes) return true;
    if (i.userTypes)
      i.userTypes.map((userType) => {
        if (userType === user_type) filterPass = true;
      });
    return filterPass;
  };

  //   const turnToObjects=(array)=>{
  //     Object.assign({},...categorizationUploadModules.map(item=> ({[key]: ""})));
  //   }
  return (
    <div className="categorization-Upload-container">
      <div className="card-row row">
        <h4 className="upload-header">Upload categorization file</h4>
        {categorizationUploadModules
          .filter(filteUserTypePermission)
          .map((module) => (
            <div key={module.id} className="card-col col s12 m6 l6 ">
              <UploadFile
                heading={module.title}
                api={module.api}
                help={module.helpText ? module.helpText : null}
                varients={module.varients || []}
              />
            </div>
          ))}
      </div>

      <div className="card-row row">
        <UploadStatusTable categorization={true} />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  let expiration = state.auth.authToken
    ? state.auth.authToken.expiration
    : 20000;

  let user_type = state.auth.authToken ? state.auth.authToken.type : null;

  return { expiration, user_type };
};
export default connect(mapStateToProps)(AdminUpload);
